import React, { useEffect } from "react";

const GFE_URL = "https://portal.gfeme.com/intake/iridescent-medical-spa";

export default function GfeRedirect() {
  useEffect(() => {
    window.location.replace(GFE_URL);
  }, []);

  return (
    <div className="py-32 text-center text-[#5C6664]" data-testid="gfe-redirect">
      Taking you to your intake form…{" "}
      <a href={GFE_URL} className="underline text-ink" data-testid="gfe-redirect-link">Continue</a>
    </div>
  );
}
